import { request } from "@/utils/request"

const url = {
  db: '/appeditor/db/',
}

/**
 * 获取项目数据库列表
 * @param {*} appId 
 * @param {*} params 
 */
export function getDbList(appId, params) {
  return request({
    url: url.db + 'list/' + appId,
    method: 'get',
    params
  })
}

/**
 * 保存项目数据库配置
 * @param {*} data 
 */
export function saveDb(data) {
  return request({
    url: url.db + 'save',
    method: 'post',
    data
  })
}

/**
 * 删除项目数据库配置
 * @param {*} ids 
 * @returns 
 */
export function deleteDbByIds(ids) {
  return request({
    url: url.db + 'remove',
    method: 'post',
    data: ids
  })
}

/**
 * 测试连接到数据库
 * @param {*} data 
 * @returns 
 */
export function testConnection(data) {
  return request({
    url: url.db + 'testConnection',
    method: 'post',
    data
  })
}

/**
 * 获取数据库中的表
 * @param {*} id 
 * @returns 
 */
export function getDbTables(params) {
  return request({
    url: url.db + 'getTables',
    method: 'get',
    params
  })
}

/**
 * 获取数据库表中的字段
 * @param {*} id 
 * @returns 
 */
export function getDbTableColumns(params) {
  return request({
    url: url.db + 'getColumns',
    method: 'get',
    params
  })
}
